import { useTranslations } from 'contexts/Translation'
import PropTypes from 'prop-types'
import { Title, Button } from '@qonsoll/react-design'
import {
  StyledFilter,
  StyledHeader,
  filterBackground,
  filterMaxHeight,
  iconStyles,
  buttonProps
} from './OfferFilter.styles'
import { CloseOutlined } from '@ant-design/icons'
import { FeatureFilter, MockupFilter, TechnologyFilter } from './components'

const OfferFilter = (props) => {
  const { filterVisibility, setFilterVisibility, filterData, setFilterData } =
    props

  // [ADDITIONAL_HOOKS]
  const { t } = useTranslations()

  // [HANDLERS]
  const handleClose = () => setFilterVisibility(false)

  return filterVisibility ? (
    <>
      <StyledHeader background={filterBackground}>
        <Title mb={2} level={4}>
          {t('Filter')}
        </Title>
        <Button
          {...buttonProps}
          onClick={handleClose}
          icon={<CloseOutlined style={iconStyles} />}
        />
      </StyledHeader>
      <StyledFilter maxHeight={filterMaxHeight} background={filterBackground}>
        <FeatureFilter filterData={filterData} setFilterData={setFilterData} />
        <MockupFilter filterData={filterData} setFilterData={setFilterData} />
        <TechnologyFilter
          filterData={filterData}
          setFilterData={setFilterData}
        />
      </StyledFilter>
    </>
  ) : null
}

OfferFilter.propTypes = {
  filterVisibility: PropTypes.bool,
  setFilterVisibility: PropTypes.func,
  filterData: PropTypes.object,
  setFilterData: PropTypes.func
}

export default OfferFilter
